// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.add-term hr {
    margin-top: 10px;
}

.delete-term-btn button {
    margin-left: 5px;
}

button .fa-plus, .fa-minus {
    color: #fff;
    margin: 0px 5px 0px 0px;
}

.term-container hr {
    margin-top: 10px;
}

.term-text-container {
    margin-right: 10px;
    /* display: flex;
    align-items: center; */
}

.term-text-container span {
    width: 40px;
}

.term-text-container input {
    width: 80px;
}

.term-text-amount-container {
    display: flex;
}`, "",{"version":3,"sources":["webpack://./src/components/CourseTerm/CourseTerm.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB;0BACsB;AAC1B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;AACjB","sourcesContent":[".add-term hr {\n    margin-top: 10px;\n}\n\n.delete-term-btn button {\n    margin-left: 5px;\n}\n\nbutton .fa-plus, .fa-minus {\n    color: #fff;\n    margin: 0px 5px 0px 0px;\n}\n\n.term-container hr {\n    margin-top: 10px;\n}\n\n.term-text-container {\n    margin-right: 10px;\n    /* display: flex;\n    align-items: center; */\n}\n\n.term-text-container span {\n    width: 40px;\n}\n\n.term-text-container input {\n    width: 80px;\n}\n\n.term-text-amount-container {\n    display: flex;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
